import { render } from "./ProblemView.vue?vue&type=template&id=5f5dca76&scoped=true"
import script from "./ProblemView.vue?vue&type=script&lang=js"
export * from "./ProblemView.vue?vue&type=script&lang=js"

import "./ProblemView.vue?vue&type=style&index=0&id=5f5dca76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5dca76"]])

export default __exports__